import { rutFilter } from 'vue-dni';

export default ({ Vue }) => {
  Vue.filter('rutFilter', rutFilter);
};



// WEBPACK FOOTER //
// ./src/plugins/vue-dni.js